(function () {
  function fitTrack(container) {
    var track = container.querySelector('.scrolling-announcement__track');
    if (!track) return;

    var groups = track.querySelectorAll('.scrolling-announcement__group');
    if (groups.length < 2) return;

    // Cache the pristine, single-pass markup the first time we see this
    // track, so repeated resizes always multiply from the original items
    // rather than compounding an already-duplicated list.
    if (!track.dataset.baseHtml) {
      track.dataset.baseHtml = groups[0].innerHTML;
    }

    var baseHtml = track.dataset.baseHtml;

    // Measure a single pass of the item list off-screen to get its true
    // rendered width at the current breakpoint/content.
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute; top:-9999px; left:-9999px; visibility:hidden; display:flex; white-space:nowrap; pointer-events:none;';
    probe.innerHTML = baseHtml;
    document.body.appendChild(probe);
    var baseWidth = probe.getBoundingClientRect().width;
    probe.remove();

    if (!baseWidth) return;

    var containerWidth = container.getBoundingClientRect().width || window.innerWidth;

    // Repeat the item list enough times that a single group is wider than
    // the visible bar. With a short item list this is the difference
    // between the marquee filling the whole section width and it only
    // ever occupying part of it, leaving blank space on wide screens.
    var reps = Math.max(1, Math.ceil(containerWidth / baseWidth) + 1);
    var filledHtml = baseHtml.repeat(reps);

    groups.forEach(function (group) {
      group.innerHTML = filledHtml;
    });
  }

  function fitAll() {
    document.querySelectorAll('.scrolling-announcement').forEach(fitTrack);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitAll, 150);
  });

  // Script is loaded with `defer`, so the DOM is already parsed here.
  fitAll();

  // Re-fit (from scratch) whenever the theme editor re-renders this section.
  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('.scrolling-announcement');
    if (!container) return;
    var track = container.querySelector('.scrolling-announcement__track');
    if (track) delete track.dataset.baseHtml;
    fitTrack(container);
  });
})();
